import ScheduleStatus from './ScheduleStatus.js';
import AnswerType from './AnswerType.js';
import ScenarioServiceRequestStatus from './ScenarioServiceRequestStatus.js';
import UserGroup from './UserGroup.js';
import ScenarioCallType from './ScenarioCallType.js';
import ScenarioAnswerActionCode from './ScenarioAnswerActionCode.js';
import ScenarioRequestType from './ScenarioRequestType.js';

// 공통으로 쓰이는 클래스들을 모아서 window.aiccCode로 노출하기 위한 모음 클래스

class AiccCode {
  constructor() {
    this.scheduleStatus = new ScheduleStatus();
    this.answerType = new AnswerType();
    this.scenarioServiceRequestStatus = new ScenarioServiceRequestStatus();
    this.UserGroup = new UserGroup();
    this.scenarioCallType = new ScenarioCallType();
    this.scenarioAnswerActionCode = new ScenarioAnswerActionCode();
    this.scenarioRequestType = new ScenarioRequestType();
  }
}

export default AiccCode;

/*
사용법 예시

aiccCode.answerType.codeMap;  // 함수 아님. getter
// 클래스에 선언한 배열 그대로 반환
// { A: "객관식", B: "주관식", C: "Y/N", D: "n점 척도", E: "N/A" }

aiccCode.answerType.valueTextArray;   // 함수 아님. getter
// 위 함수는 아래를 반환합니다.
// [
//   { value: 'A', text: '객관식' },
//   { value: 'B', text: '주관식' },
//   { value: 'C', text: 'Y/N' },
//   { value: 'D', text: 'n점 척도' },
//   { value: 'E', text: 'N/A' },  
// ]

aiccCode.answerType.codeText('B');   // 주관식
aiccCode.answerType.codeText('Z');   // undefined
*/